module.exports = __webpack_public_path__ + "img/none.a717c88b.png";